import React, { useState, useRef, useEffect } from "react";
import logo from "../../img/full_logoC.png";
import axios from "axios";
import "./ValForm.css";
import Countries from "./Countries";
import Swal from "sweetalert2";
import bg_img from "../../img/1233.png";
import { IoAddCircle } from "react-icons/io5";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

const EmploymentForm = ({ Ip }) => {
  const resumeRef = useRef(null);
  const applicantphotoRef = useRef(null);
  const passportRef = useRef(null);
  const positionRef = useRef(null);
  const technicalRef = useRef(null);
  const fnameRef = useRef(null);
  const fathernameRef = useRef(null);
  const stateRef = useRef(null);
  const lnameRef = useRef(null);
  const genderRef = useRef(null);
  const appliedworkedRef = useRef(null);
  const misdemeanorRef = useRef(null);
  // const appliedpositionRef = useRef(null);
  const employedRef = useRef(null);
  const martialRef = useRef(null);
  const nationalityRef = useRef(null);
  const postalRef = useRef(null);
  const dofRef = useRef(null);
  const cityRef = useRef(null);
  const phRef = useRef(null);
  const perCountryRef = useRef(null);
  const perCityRef = useRef(null);
  const perStreetRef = useRef(null);
  const perNumberRef = useRef(null);
  const emailRef = useRef(null);
  const relativevalooresRef = useRef(null);
  const salaryRef = useRef(null);
  const spousenameRef = useRef(null);

  const [fname, setFirstName] = useState("");
  const [fathername, setFatherName] = useState("");
  const [lname, setLastName] = useState("");
  const [gender, setGender] = useState("");
  const [marital_status, setMaritalStatus] = useState("");
  const [nbOfchildren, setNbOfchildren] = useState(0);
  const [nationality, setNationality] = useState("");
  const [othernationality, setOtherNationality] = useState("");
  const [dof, setDof] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [postal, setPostal] = useState("");
  const [phonenumber, setPhonenumber] = useState();
  const [email, setEmail] = useState("");
  const [perCountry, setPerCountry] = useState("");
  const [perCity, setPerCity] = useState("");
  const [perStreet, setPerStreet] = useState("");
  const [perNumber, setPerNumber] = useState("");
  const [nbofdependents, setNbOfDependents] = useState(0);
  const [hobbies, setHobbies] = useState("");
  const [employed, setIsEmployed] = useState(false);
  const [isApplied, setIsApplied] = useState(false);
  const [isAvailable_travel, setisAvailableTravel] = useState(false);
  const [educationData, setEducationData] = useState([
    { degree: "", institute: "", date: "", location: "" },
    { degree: "", institute: "", date: "", location: "" },
    { degree: "", institute: "", date: "", location: "" },
  ]);
  const [spousename, setSpouseName] = useState("");
  const [childrenNames, setChildrenNames] = useState([]);

  useEffect(() => {
    setChildrenNames(Array(nbOfchildren).fill(''));
  }, [nbOfchildren]);

  useEffect(() => {
    const trackPageLoad = async () => {
      try {
        const response = await axios.post(`${Ip}controllers/track.php`);
        const { id } = response.data;
        console.log("Page load tracking response:", id);

        // Store the ID in localStorage (or in state if persistent session)
        localStorage.setItem("tracking_id", id);
      } catch (err) {
        console.error("Page load tracking failed", err);
      }
    };

    trackPageLoad();
  }, []);

  useEffect(() => {
    const startTime = Date.now();

    const handleUnload = () => {
      const endTime = Date.now();
      const duration = Math.round((endTime - startTime) / 1000);
      const trackingId = localStorage.getItem("tracking_id");

      if (!trackingId) return;

      const formData = new FormData();
      formData.append("id", trackingId);
      formData.append("duration", duration);

      // localStorage.setItem("duration", duration);
      navigator.sendBeacon(`${Ip}controllers/track_duration.php`, formData);
    };

    window.addEventListener("beforeunload", handleUnload);
    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, []);

  const [languageProficiency, setLanguageProficiency] = useState({
    speaking: {
      English: "",
      French: "",
      Arabic: "",
    },
    writing: {
      English: "",
      French: "",
      Arabic: "",
    },
  });
  const [certifications, setCertifications] = useState([
    { name: "", duration: "", year: "", institution: "" },
    { name: "", duration: "", year: "", institution: "" },
    { name: "", duration: "", year: "", institution: "" },
    { name: "", duration: "", year: "", institution: "" },
  ]);
  const [references, setReferences] = useState([
    { name: "", placeOfWork: "", jobTitle: "", telNumber: "" },
    { name: "", placeOfWork: "", jobTitle: "", telNumber: "" },
    { name: "", placeOfWork: "", jobTitle: "", telNumber: "" },
  ]);

  const [companies, setCompanies] = useState([
    {
      title: "Current Job",
      company_name: "",
      number_of_employees: "",
      type_of_business: "",
      address: "",
      company_email: "",
      company_phone: "",
      position_held: "",
      staff_supervised: "",
      supervisor_name: "",
      employment_date: "",
      departure_date: "",
      reasons_for_leaving: "",
      role_and_responsibilities: "",
    },
    {
      title: "Previous Job #1",
      company_name: "",
      number_of_employees: "",
      type_of_business: "",
      address: "",
      company_email: "",
      company_phone: "",
      position_held: "",
      staff_supervised: "",
      supervisor_name: "",
      employment_date: "",
      departure_date: "",
      reasons_for_leaving: "",
      role_and_responsibilities: "",
    },
  ]);

  const addPreviousJob = () => {
    const previousJobsCount = companies.length - 1;
    setCompanies([
      ...companies,
      {
        title: `Previous Job #${previousJobsCount + 1}`,
        company_name: "",
        number_of_employees: "",
        type_of_business: "",
        address: "",
        company_email: "",
        company_phone: "",
        position_held: "",
        staff_supervised: "",
        supervisor_name: "",
        employment_date: "",
        departure_date: "",
        reasons_for_leaving: "",
        role_and_responsibilities: "",
      },
    ]);
  };

  const handleCompanyChange = (index, field, value) => {
    const newCompanies = [...companies];
    newCompanies[index][field] = value;
    setCompanies(newCompanies);
  };

  const [computer_skills, setComputerSkills] = useState("");
  const [relativevaloores, setRelativeValoores] = useState("");
  const [relative_job_title_location, setRelativeJobLocation] = useState("");
  const [applied_worked, setAppliedWorked] = useState("");
  const [applied_position_location, setAppliedPosition] = useState("");
  const [applied_date, setAppliedDate] = useState("");
  const [available_travel, setAvailableTravel] = useState("");
  const [available_travel_percent, setAvailableTravelPercent] = useState("");
  const [misdemeanor, setMisdemeanor] = useState("");
  const [aspirations, setAspirations] = useState("");
  const [salary, setSalary] = useState("");
  const [resume, setResume] = useState("");
  const [applicantphoto, setApplicantPhoto] = useState("");
  const [passport, setPassport] = useState("");
  const [selectedPositions, setSelectedPositions] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (index, field, value) => {
    const newData = [...educationData];
    newData[index][field] = value;
    setEducationData(newData);
  };

  const handleProficiencyChange = (type, language, level) => {
    setLanguageProficiency((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [language]: level,
      },
    }));
  };

  const handleCertificationChange = (index, field, value) => {
    const updatedCertifications = [...certifications];
    updatedCertifications[index][field] = value;
    setCertifications(updatedCertifications);
  };

  const handleReferenceChange = (index, field, value) => {
    const updatedReferences = [...references];
    updatedReferences[index][field] = value;
    setReferences(updatedReferences);
  };
  const LanguageTable = ({ type }) => {
    const languages = ["English", "French", "Arabic"];

    return (
      <table>
        <thead>
          <tr>
            <th>Language</th>
            <th>Average</th>
            <th>Good</th>
            <th>Excellent</th>
          </tr>
        </thead>
        <tbody>
          {languages.map((lang) => (
            <tr key={lang}>
              <td>{lang}</td>
              {["Average", "Good", "Excellent"].map((level) => (
                <td key={level}>
                  <input
                    type="radio"
                    name={`${lang.toLowerCase()}_${type}`}
                    value={level}
                    checked={languageProficiency[type][lang] === level}
                    onChange={() => handleProficiencyChange(type, lang, level)}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;

    setSelectedPositions((prevState) => {
      if (checked) {
        return [...prevState, value];
      } else {
        return prevState.filter((position) => position !== value);
      }
    });
  };
  const handleCheckboxSkillsChange = (e) => {
    const { value, checked } = e.target;

    setSelectedSkills((prevState) => {
      if (checked) {
        return [...prevState, value];
      } else {
        return prevState.filter((skill) => skill !== value);
      }
    });
  };

  const fieldsToCheck = [
    { value: fname, ref: fnameRef },
    { value: fathername, ref: fathernameRef },
    { value: lname, ref: lnameRef },
    { value: dof, ref: dofRef },
    { value: phonenumber, ref: phRef },
    { value: email, ref: emailRef },
    { value: gender, ref: genderRef },
    { value: marital_status, ref: martialRef },
    { value: nationality, ref: nationalityRef },
    {
      value: selectedPositions.length > 0 ? selectedPositions : null,
      ref: positionRef,
    },
    { value: applicantphoto, ref: applicantphotoRef },
    { value: resume, ref: resumeRef },
    { value: passport, ref: passportRef },
    { value: postal, ref: postalRef },
    { value: city, ref: cityRef },
    { value: state, ref: stateRef },
    { value: perCountry, ref: perCountryRef },
    { value: perCity, ref: perCityRef },
    { value: perStreet, ref: perStreetRef },
    { value: perNumber, ref: perNumberRef },
    {
      value: selectedSkills.length > 0 ? selectedSkills : null,
      ref: technicalRef,
    },
    { value: relativevaloores, ref: relativevalooresRef },
    { value: applied_worked, ref: appliedworkedRef },
    // { value: applied_position_location, ref: appliedpositionRef },
    { value: misdemeanor, ref: misdemeanorRef },
    { value: salary, ref: salaryRef },
  ];
  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (isLoading) return;
    // setIsLoading(true);

    for (const field of fieldsToCheck) {
      if (!field.value) {
        if (field.ref?.current) {
          field.ref.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          field.ref.current.focus();
          return;
        }
      }
    }

    if (marital_status === "Married" && !spousename) {
      if (spousenameRef?.current) {
        spousenameRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        spousenameRef.current.focus();
      }
      return;
    }

    if (!email.includes("@") || !email.includes(".com")) {
      alert("Please enter a valid email address");
      return;
    }
    const addressObject = {
      country: perCountry,
      city: perCity,
      street: perStreet,
      phnumber: perNumber,
    };
    if (!resume || !applicantphoto || !passport) {
      Swal.fire({
        icon: "error",
        title: "Missing Files",
        text: "Please upload your Resume, Photo, and Passport before submitting.",
        confirmButtonText: "Okay",
        confirmButtonColor: "#051C2C",
      });
      return;
    }
    if (resume && resume.size > 3 * 1024 * 1024) {
      Swal.fire({
        icon: "error",
        title: "Resume Too Large",
        text: "Resume must be smaller than 3 MB.",
        confirmButtonText: "Okay",
        confirmButtonColor: "#051C2C",
      });
      resumeRef.current?.focus();
      return;
    }
    if (applicantphoto && applicantphoto.size > 3 * 1024 * 1024) {
      Swal.fire({
        icon: "error",
        title: "Photo Too Large",
        text: "Photo must be smaller than 3 MB.",
        confirmButtonText: "Okay",
        confirmButtonColor: "#051C2C",
      });
      applicantphotoRef.current?.focus();
      return;
    }
    if (passport && passport.size > 3 * 1024 * 1024) {
      Swal.fire({
        icon: "error",
        title: "Passport Photo Too Large",
        text: "Passport must be smaller than 3 MB.",
        confirmButtonText: "Okay",
        confirmButtonColor: "#051C2C",
      });
      passportRef.current?.focus();
      return;
    }
    try {
      Swal.fire({
        title: "Submitting...",
        html: "Please wait a moment while your application is being submitted.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const formdata = new FormData();
      formdata.append("fname", fname);
      formdata.append("fathername", fathername);
      formdata.append("lname", lname);
      formdata.append("position", JSON.stringify(selectedPositions));
      formdata.append("skills", JSON.stringify(selectedSkills));
      formdata.append("gender", gender);
      formdata.append("martialstatus", marital_status);
      formdata.append("nbofchildren", nbOfchildren);
      formdata.append("children_names", JSON.stringify(childrenNames));
      formdata.append("nationality", nationality);
      formdata.append("othernationality", othernationality);
      formdata.append("dateofbirth", dof);
      formdata.append("nbofdependents", nbofdependents);
      formdata.append("state", state);
      formdata.append("city", city);
      formdata.append("postalcode", postal);
      formdata.append("phonenumber", phonenumber);
      formdata.append("email", email);
      formdata.append("perAddress", JSON.stringify(addressObject));
      formdata.append("educationData", JSON.stringify(educationData));
      formdata.append(
        "languageProficiency",
        JSON.stringify(languageProficiency),
      );
      formdata.append("certifications", JSON.stringify(certifications));
      formdata.append("computer_skills", computer_skills);
      formdata.append("employmenthistory", JSON.stringify(companies));
      formdata.append("relativevaloores", relativevaloores);
      formdata.append(
        "relative_job_title_location",
        relative_job_title_location,
      );
      formdata.append("applied_worked", applied_worked);
      formdata.append("applied_position_location", applied_position_location);
      formdata.append("applied_date", applied_date);
      formdata.append("available_travel", available_travel);
      formdata.append("available_travel_percent", available_travel_percent);
      formdata.append("misdemeanor", misdemeanor);
      formdata.append("aspirations", aspirations);
      formdata.append("salary", salary);
      formdata.append("references_contact", JSON.stringify(references));
      formdata.append("passport", passport);
      formdata.append("resume", resume);
      formdata.append("applicantphoto", applicantphoto);
      formdata.append("hobbies", hobbies);
      formdata.append("spousename", spousename);
      formdata.append("Action", "database");
      const response = await axios.post(
        `${Ip}controllers/jobform.php`,
        formdata,
      );

      if (response.data["success"] === true) {
        Swal.close();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Your form has been submitted successfully.",
          confirmButtonText: "Okay",
          confirmButtonColor: "#051C2C",
        }).then(() => {
          window.location.href = "/";
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "There was an error submitting your form. Please try again.",
          confirmButtonText: "Okay",
          confirmButtonColor: "#051C2C",
        });
      }
    } catch (error) {
      console.error("Submission error:", error);
      Swal.fire({
        icon: "error",
        title: "Unexpected Error!",
        text: "An unexpected error occurred. Please try again later.",
        confirmButtonText: "Okay",
        confirmButtonColor: "#051C2C",
      });
    }
  };

  const allPositions = [
    "Project Manager",
    "DevOps Engineer",
    "Software Developer Engineer",
    "Business Development Regional - Europe",
    "Business Development Regional - GCC",
    "Web Developer",
    "Data Analytics Lead",
    "Database Administrator",
    "Cyber Security Specialist",
    "Mid / Senior Data Scientist",
    "Oracle Developer",
    "Mid Web Developer",
    "Senior Business Analyst",
    "Database Integrator",
    "Junior Web Designer",
    "Junior Business Analyst",
    "Junior IT",
    "Quality Assurance Engineer",
    "Machine Learning Engineer",
    "Senior Web Designer",
    "Weblogic / Websphere / Tomcat Admin",
    "Software Architect",
    "Account Manager",
    "Marketing Manager",
    "Other",
  ];
  const technicalSkills = [
    "Docker",
    "kubernetes",
    "Jenkins",
    "Git",
    "CI/CD",
    "PostgreSQL",
    "MySQL",
    "MongoDB",
    "Oracle",
    "Node.js",
    "React.js",
    "Angular",
    "Python",
    "Java",
    "Spring Boot",
    "Linux",
    "AWS",
    "Azure",
    "Google Cloud",
    "WSO2",
    "Other",
  ];

  const half = Math.ceil(allPositions.length / 2);
  const leftColumn = allPositions.slice(0, half);
  const rightColumn = allPositions.slice(half);

  return (
    <div style={{ padding: "20px" }}>
      {/* ,backgroundImage: `url(${bg_img})`, backgroundSize: 'cover',backgroundAttachment: 'fixed',width:'100vw' */}
      {/* <form className="ValForm" action="/submit" method="post" encType="multipart/form-data" noValidate> */}
      <form
        className="ValForm"
        noValidate
        encType="multipart/form-data"
        onSubmit={handleSubmit}
      >
        <div className="valform d-flex flex-column align-items-center text-center">
          <img src={logo} width={200} alt="VALOORES" loading="lazy" />
          <h1 style={{ fontWeight: "550" }}>VALOORES Employment Form</h1>
          <h4 style={{ fontWeight: "550" }}>
            You have the value, we bring you the added value
          </h4>
        </div>

        {/* Personal Info */}
        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          Personal Information
        </h2>
        <label>
          First Name<span className="star">*</span>
          <input
            type="text"
            name="first_name"
            value={fname}
            onChange={(e) => setFirstName(e.target.value)}
            ref={fnameRef}
            required
          />
        </label>
        <label>
          Father's Name<span className="star">*</span>
          <input
            type="text"
            name="father_name"
            value={fathername}
            onChange={(e) => setFatherName(e.target.value)}
            ref={fathernameRef}
            required
          />
        </label>
        <label>
          Last Name<span className="star">*</span>
          <input
            type="text"
            name="last_name"
            value={lname}
            onChange={(e) => setLastName(e.target.value)}
            ref={lnameRef}
            required
          />
        </label>
        <label>
          Date of Birth<span className="star">*</span>
          <input
            type="date"
            name="dob"
            value={dof}
            ref={dofRef}
            onChange={(e) => setDof(e.target.value)}
            required
          />
        </label>
        <label>
          Phone Number<span className="star">*</span>
          <PhoneInput
            defaultCountry="lb"
            value={phonenumber}
            ref={phRef}
            onChange={(phone) => setPhonenumber(phone)}
            inputProps={{
              name: "phone",
              required: true,
            }}
            style={{ flexWrap: "nowrap!improtant" }}
          />
          {/* <input type="tel" name="phone" 
           value={phonenumber}
           ref={phRef}
           onChange={(e) => setPhonenumber(e.target.value)}
          required /> */}
        </label>
        <label>
          Email<span className="star">*</span>
          <input
            type="email"
            name="email"
            value={email}
            ref={emailRef}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        {/* About */}
        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          About
        </h2>

        <label>
          Gender<span className="star">*</span>
          <select
            name="gender"
            value={gender}
            ref={genderRef}
            onChange={(e) => setGender(e.target.value)}
            required
          >
            <option value="">Select</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </label>

        <label>
          Marital Status<span className="star">*</span>
          <select
            name="marital_status"
            value={marital_status}
            onChange={(e) => setMaritalStatus(e.target.value)}
            ref={martialRef}
            required
          >
            <option value="">Select</option>
            <option value="Single">Single</option>
            <option value="Married">Married</option>
            <option value="Divorced">Divorced</option>
            <option value="Widowed">Widowed</option>
          </select>
        </label>

        {marital_status === "Married" && (
          <label>
            Spouse's Name <span className="star">*</span>
            <input
              type="text"
              name="spouse_name"
              value={spousename}
              onChange={(e) => setSpouseName(e.target.value)}
              ref={spousenameRef}
              required
            />
          </label>
        )}

        <label>
          Number Of Children
          <input
            type="number"
            name="children"
            value={nbOfchildren}
            onChange={(e) => setNbOfchildren(Number(e.target.value))}
          />
        </label>
        <label>
          Number Of Dependents
          <input
            type="number"
            name="dependents"
            value={nbofdependents}
            onChange={(e) => setNbOfDependents(Number(e.target.value))}
          />
        </label>
        {nbOfchildren > 0 && Array.from({length: nbOfchildren}, (_, index) => (
          <label key={index}>
            Name of Child {index + 1}
            <input
              type="text"
              name={`children[${index}]`}
              value={childrenNames[index] || ''}
              onChange={(e) => {
                const newNames = [...childrenNames];
                newNames[index] = e.target.value;
                setChildrenNames(newNames);
              }}
            />
          </label>
        ))}

        <label>
          Citizenship/Nationality<span className="star">*</span>
          <select
            name="citizenship"
            value={nationality}
            ref={nationalityRef}
            onChange={(e) => setNationality(e.target.value)}
            required
          >
            <option value="">Select</option>
            {Countries.map((country, index) => (
              <option key={index} value={country.name}>
                {country.name}
              </option>
            ))}
          </select>
        </label>

        <label>
          Other Citizenship/Nationality
          <select
            name="other_citizenship"
            value={othernationality}
            onChange={(e) => setOtherNationality(e.target.value)}
          >
            <option value="">None</option>
            {Countries.map((country) => (
              <option key={`${country.name}--2`} value={country.name}>
                {country.name}
              </option>
            ))}
          </select>
        </label>

        {/* Position Details */}
        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          Position Details
        </h2>
        <label>
          Position(s) Applied for<span className="star">*</span>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={{ flex: 1 }} ref={positionRef}>
              {leftColumn.map((position) => (
                <label
                  key={position}
                  style={{
                    marginBottom: "5px",
                    display: "block",
                    width: "100%",
                  }}
                >
                  <input
                    type="checkbox"
                    name="position"
                    value={position}
                    onChange={handleCheckboxChange}
                    checked={selectedPositions.includes(position)}
                  />
                  {position}
                </label>
              ))}
            </div>
            <div style={{ flex: 1 }}>
              {rightColumn.map((position) => (
                <label
                  key={position}
                  style={{
                    marginBottom: "5px",
                    display: "block",
                    width: "100%",
                  }}
                >
                  <input
                    type="checkbox"
                    name="position"
                    value={position}
                    onChange={handleCheckboxChange}
                    ref={positionRef}
                    checked={selectedPositions.includes(position)}
                  />
                  {position}
                </label>
              ))}
            </div>
          </div>
        </label>
        <div ref={employedRef}>
          <label>
            Are You Currently Employed?<span className="star">*</span>
          </label>
          <div>
            <input
              type="radio"
              id="employed_yes"
              name="employed"
              value="Yes"
              required
            />
            <label htmlFor="employed_yes">Yes</label>
            <input type="radio" id="employed_no" name="employed" value="No" />
            <label htmlFor="employed_no">No</label>
          </div>
        </div>

        <label>
          If Yes, Include The Period of Legal Notice
          <input type="text" name="notice_period" placeholder="e.g., 1 month" />
        </label>

        {/* Upload Documents */}
        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          Upload Documents
        </h2>
        <label>
          Upload Your Image<span className="star">*</span>
          <input
            type="file"
            name="applicantphoto"
            onChange={(e) => setApplicantPhoto(e.target.files[0])}
            ref={applicantphotoRef}
            className="form-control"
            required
          />
        </label>
        <label>
          Upload Resume<span className="star">*</span>
          <input
            type="file"
            name="resume"
            accept=".pdf,.doc,.docx,"
            onChange={(e) => setResume(e.target.files[0])}
            ref={resumeRef}
            className="form-control"
            required
          />
        </label>

        <label>
          Upload Passport Photo<span className="star">*</span>
          <input
            type="file"
            name="photo"
            accept=".jpg,.jpeg,.png"
            onChange={(e) => setPassport(e.target.files[0])}
            ref={passportRef}
            className="form-control"
            required
          />
        </label>

        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          Present Address
        </h2>
        <label>
          Country <span className="star">*</span>
          <input
            type="text"
            name="state"
            value={state}
            ref={stateRef}
            onChange={(e) => setState(e.target.value)}
          />
        </label>
        <label>
          City<span className="star">*</span>
          <input
            type="text"
            name="city"
            value={city}
            ref={cityRef}
            onChange={(e) => setCity(e.target.value)}
            required
          />
        </label>
        <label>
          Street <span className="star">*</span>
          <input
            type="text"
            name="postal_code"
            value={postal}
            ref={postalRef}
            onChange={(e) => setPostal(e.target.value)}
          />
        </label>
        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          Permanent Address
        </h2>
        <label>
          Country <span className="star">*</span>
          <input
            type="text"
            name="permanent_Country"
            value={perCountry}
            ref={perCountryRef}
            onChange={(e) => setPerCountry(e.target.value)}
          />
        </label>
        <label>
          City<span className="star">*</span>
          <input
            type="text"
            name="permanent_city"
            value={perCity}
            ref={perCityRef}
            onChange={(e) => setPerCity(e.target.value)}
            required
          />
        </label>
        <label>
          Street <span className="star">*</span>
          <input
            type="text"
            name="permanent_street"
            value={perStreet}
            ref={perStreetRef}
            onChange={(e) => setPerStreet(e.target.value)}
          />
        </label>
        <label>
          Phone Number <span className="star">*</span>
          {/* <input type="text" name="permanent_phone"
           value={perNumber}
           ref={perNumberRef}
           onChange={(e) => setPerNumber(e.target.value)}
          /> */}
          <div>
            <PhoneInput
              ref={perNumberRef}
              defaultCountry="lb"
              value={perNumber}
              onChange={(pernum) => setPerNumber(pernum)}
              inputProps={{
                name: "permanent_phone",
                required: true,
              }}
              style={{ flexWrap: "nowrap!improtant" }}
            />
          </div>
        </label>

        {/* Educational Background */}
        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          Educational Background
        </h2>
        <p>Start from latest</p>
        <table>
          <thead>
            <tr>
              <th>Degree/Major</th>
              <th>Institute</th>
              <th>Date</th>
              <th>Country, City</th>
            </tr>
          </thead>
          <tbody>
            {educationData.map((item, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="text"
                    value={item.degree}
                    onChange={(e) =>
                      handleInputChange(index, "degree", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={item.institute}
                    onChange={(e) =>
                      handleInputChange(index, "institute", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={item.date}
                    onChange={(e) =>
                      handleInputChange(index, "date", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={item.location}
                    onChange={(e) =>
                      handleInputChange(index, "location", e.target.value)
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Language Proficiency */}
        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          Language Proficiency
        </h2>
        <p>Speaking</p>
        <LanguageTable type="speaking" />
        <p>Writing</p>
        <LanguageTable type="writing" />

        {/* Certificates */}
        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          Certificates
        </h2>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Duration</th>
              <th>Year</th>
              <th>Institution</th>
            </tr>
          </thead>
          <tbody>
            {certifications.map((cert, i) => (
              <tr key={i}>
                <td>
                  <input
                    type="text"
                    value={cert.name}
                    onChange={(e) =>
                      handleCertificationChange(i, "name", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={cert.duration}
                    onChange={(e) =>
                      handleCertificationChange(i, "duration", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={cert.year}
                    onChange={(e) =>
                      handleCertificationChange(i, "year", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={cert.institution}
                    onChange={(e) =>
                      handleCertificationChange(
                        i,
                        "institution",
                        e.target.value,
                      )
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          Technical Skills <span className="star">*</span>
        </h2>
        <div className="skills-grid" ref={technicalRef}>
          {technicalSkills.map((skill) => (
            <label
              key={skill}
              style={{
                display: "block",
                marginBottom: "5px",
              }}
            >
              <input
                type="checkbox"
                name="position"
                value={skill}
                onChange={handleCheckboxSkillsChange}
                checked={selectedSkills.includes(skill)}
              />
              {skill}
            </label>
          ))}
        </div>
        <label>
          Additional Skills :
          <textarea
            name="computer_skills"
            rows="4"
            value={computer_skills}
            onChange={(e) => setComputerSkills(e.target.value)}
          />
        </label>

        {/* Employment History */}
        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          Employment History{" "}
          <span style={{ color: "red" }}>Start from latest</span>
        </h2>

        <table>
          <thead>
            {companies.map((company, index) => (
              <tr key={index}>
                <td>
                  {/* <h2>Company {String.fromCharCode(65 + index)}.</h2> */}
                  {/* <h2>{index === 0 ? "Current Job" : "Previous Job"}</h2> */}
                  <h2>{company.title}</h2>
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}
                  >
                    {[
                      {
                        label: "Name of Company",
                        name: "company_name",
                        type: "text",
                      },
                      {
                        label: "Number of Employees",
                        name: "number_of_employees",
                        type: "text",
                      },
                      {
                        label: "Type of Business",
                        name: "type_of_business",
                        type: "text",
                      },
                      { label: "Address", name: "address", type: "text" },
                      {
                        label: "Company E-mail",
                        name: "company_email",
                        type: "email",
                      },
                      {
                        label: "Phone Number",
                        name: "company_phone",
                        type: "tel",
                      },
                      {
                        label: "Position Held",
                        name: "position_held",
                        type: "text",
                      },
                      {
                        label: "Number of Staff Supervised",
                        name: "staff_supervised",
                        type: "text",
                      },
                      {
                        label: "Name & Title of Supervisor",
                        name: "supervisor_name",
                        type: "text",
                      },
                      {
                        label: "Start Date",
                        name: "employment_date",
                        type: "date",
                      },
                      {
                        label: "End Date",
                        name: "departure_date",
                        type: "date",
                      },
                    ].map((inputField, i) => (
                      <div style={{ flex: "1 1 30%" }} key={i}>
                        <label>
                          {inputField.label}
                          <input
                            type={inputField.type}
                            name={inputField.name}
                            value={company[inputField.name]}
                            onChange={(e) =>
                              handleCompanyChange(
                                index,
                                inputField.name,
                                e.target.value,
                              )
                            }
                            placeholder={inputField.label}
                          />
                        </label>
                      </div>
                    ))}
                  </div>

                  <div style={{ marginTop: "20px" }}>
                    <label>
                      Reasons for Leaving
                      <textarea
                        name="reasons_for_leaving"
                        rows="4"
                        placeholder="Reasons for Leaving"
                        value={company.reasons_for_leaving}
                        onChange={(e) =>
                          handleCompanyChange(
                            index,
                            "reasons_for_leaving",
                            e.target.value,
                          )
                        }
                      />
                    </label>
                  </div>

                  <div style={{ marginTop: "20px" }}>
                    <label>
                      Role and Responsibilities
                      <textarea
                        name="role_and_responsibilities"
                        rows="4"
                        placeholder="Describe your Role and Responsibilities"
                        value={company.role_and_responsibilities}
                        onChange={(e) =>
                          handleCompanyChange(
                            index,
                            "role_and_responsibilities",
                            e.target.value,
                          )
                        }
                      />
                    </label>
                  </div>
                </td>
              </tr>
            ))}
          </thead>
        </table>
        <button
          type="button"
          onClick={addPreviousJob}
          style={{ width: "20vw" }}
        >
          Other Previous Job <IoAddCircle></IoAddCircle>
        </button>

        {/* Miscellaneous */}
        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          Miscellaneous
        </h2>
        <label>
          Do you have any relatives working at VALOORES?{" "}
          <span className="star">*</span>
          <select
            name="position"
            value={relativevaloores}
            ref={relativevalooresRef}
            onChange={(e) => {
              setRelativeValoores(e.target.value);
              setIsEmployed(e.target.value === "Yes");
            }}
            required
          >
            <option value="">Select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </label>
        <label>
          Job Title/Location
          <input
            type="text"
            name="previous_application"
            value={relative_job_title_location}
            placeholder="Job Title/Location"
            onChange={(e) => setRelativeJobLocation(e.target.value)}
            disabled={!employed}
            required={employed}
          />
          <span style={{ fontSize: "10px", color: "gray" }}>
            If Yes, Job Title/Location
          </span>
        </label>
        {/* <label>
          Job Title/Location <input type="text" name="previous_application"   
          value={relative_job_title_location}
           onChange={(e) => setRelativeJobLocation(e.target.value)} />{" "}
          <span style={{ fontSize: "10px", color: "gray" }}>
            If Yes, Job Title/Location
          </span>
        </label> */}
        <label>
          Have You Ever Applied/ Worked for a Position at VALOORES ?{" "}
          <span className="star">*</span>
          <select
            name="position"
            ref={appliedworkedRef}
            value={applied_worked}
            onChange={(e) => {
              setAppliedWorked(e.target.value);
              setIsApplied(e.target.value === "Yes");
            }}
            required
          >
            <option value="">Select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </label>
        <label>
          Position/Location
          <input
            type="text"
            name="legal_history"
            // ref={appliedpositionRef}
            placeholder="Position/Location"
            value={applied_position_location}
            disabled={!isApplied}
            onChange={(e) => setAppliedPosition(e.target.value)}
          />{" "}
          <span style={{ fontSize: "10px", color: "gray" }}>
            If Yes, Position/Location
          </span>
          <br />
          Date
          <input
            type="date"
            name="legal_historydob"
            value={applied_date}
            disabled={!isApplied}
            onChange={(e) => setAppliedDate(e.target.value)}
          />{" "}
          <span style={{ fontSize: "10px", color: "gray" }}>Date</span>
          <br />
          Are You Available To Travel?
          {["Yes", "No"].map((level) => (
            <label key={level} style={{ marginRight: "10px" }}>
              <input
                type="radio"
                name="radiobuttravel"
                value={level}
                checked={available_travel === level}
                onChange={(e) => {
                  setAvailableTravel(e.target.value);
                  setisAvailableTravel(e.target.value === "Yes");
                }}
              />
              {level}
            </label>
          ))}
        </label>
        <label>
          If yes, how available are you?
          <select
            name="position"
            value={available_travel_percent}
            disabled={!isAvailable_travel}
            onChange={(e) => setAvailableTravelPercent(e.target.value)}
            required
          >
            <option value="0">0%</option>
            <option value="30">30%</option>
            <option value="60">60%</option>
            <option value="80">80%</option>
          </select>
        </label>
        <label>
          Have You Ever Been Convicted of a Misdemeanor or Legal Offense?{" "}
          <span className="star">*</span>
          <div ref={misdemeanorRef}>
            {["Yes", "No"].map((level) => (
              <label key={level} style={{ marginRight: "10px" }}>
                <input
                  type="radio"
                  name="radiobutoffense"
                  value={level}
                  checked={misdemeanor === level}
                  onChange={(e) => setMisdemeanor(e.target.value)}
                />
                {level}
              </label>
            ))}
          </div>
        </label>
        <label>
          What are your career aspirations?
          <textarea
            name="career_aspirations"
            rows="4"
            value={aspirations}
            onChange={(e) => setAspirations(e.target.value)}
          />
        </label>

        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          Hobbies<span className="star">*</span>
        </h2>

        <label>
          <textarea
            name="hobbies"
            rows="4"
            value={hobbies}
            onChange={(e) => setHobbies(e.target.value)}
          />
        </label>

        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          Please specify your minimum expected salary in USD.{" "}
          <span className="star">*</span>
        </h2>
        <label>
          {/* Please specify a minimum expected salary in USD */}
          <input
            type="text"
            placeholder="Please specify a number or range (No need to put $ symbol) "
            name="salary"
            value={salary}
            ref={salaryRef}
            onChange={(e) => setSalary(e.target.value)}
          />
        </label>

        {/* References */}
        <h2
          style={{
            backgroundColor: "#f2f2f2",
            padding: "10px",
            fontWeight: "550",
          }}
        >
          References
        </h2>
        <p>
          List those familiar with your job performance, personal
          characteristics, and who have known you a minimum of one year. DO NOT
          LIST RELATIVES.
        </p>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Place of Work</th>
              <th>Job Title</th>
              <th>Tel. Number</th>
            </tr>
          </thead>
          <tbody>
            {references.map((ref, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="text"
                    name={`ref_name${index + 1}`}
                    value={ref.name}
                    onChange={(e) =>
                      handleReferenceChange(index, "name", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name={`ref_PlaceOfWork${index + 1}`}
                    value={ref.placeOfWork}
                    onChange={(e) =>
                      handleReferenceChange(
                        index,
                        "placeOfWork",
                        e.target.value,
                      )
                    }
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name={`ref_JobTitle${index + 1}`}
                    value={ref.jobTitle}
                    onChange={(e) =>
                      handleReferenceChange(index, "jobTitle", e.target.value)
                    }
                  />
                </td>
                <td>
                  <input
                    type="tel"
                    name={`ref_TelNumber${index + 1}`}
                    value={ref.telNumber}
                    onChange={(e) =>
                      handleReferenceChange(index, "telNumber", e.target.value)
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ marginTop: "20px" }}>
          {/* <button type="submit" onClick={(e) => handleSubmit(e)}>
          Submit Application
        </button> */}
          <button type="submit">Submit Application</button>
        </div>
      </form>
    </div>
  );
};

export default EmploymentForm;
